export default __webpack_public_path__ + "static/media/wednesday-solihull.811e36c7.jpeg";